export default "__VITE_ASSET__USDJV7pD__"